"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _EditHouseshop = _interopRequireDefault(require("./EditHouseshop.vue"));
var companyApi = _interopRequireWildcard(require("@/api/companyApi.js"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var storeApi = _interopRequireWildcard(require("@/api/store"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    EditHouseshop: _EditHouseshop.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      supplierLists: [],
      initSupplierId: null,
      initSupplierName: null
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _ref = this.$route.query || {},
      supplierId = _ref.supplierId,
      supplierName = _ref.supplierName;
    this.initSupplierId = Number(supplierId) || null;
    this.initSupplierName = supplierName || null;
    this.$set(this.listPram, 'supplierId', this.initSupplierId || null);
    this.searchSupplier(supplierName || '');
    this.handlerGetListData(this.listPram);
  },
  methods: {
    throttle: _throttle.default,
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      companyApi.houseLists(pram).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    handlerOpenEdit: function handlerOpenEdit(row) {
      this.$refs['EditHouseshopRef'].openInit(row, this.initSupplierId, this.initSupplierName);
    },
    handlerDelete: function handlerDelete(id) {
      var _this2 = this;
      this.$confirm('删除后不能恢复，是否确认删除？', '提示').then(function (result) {
        companyApi.deleteHouse(id).then(function (data) {
          _this2.$message.success('删除数据成功');
          _this2.handlerGetListData(_this2.listPram);
        });
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    searchSupplier: function searchSupplier() {
      var _this3 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.supplierLists = [];
      storeApi.getSupplierApi({
        keyword: keyword
      }).then(function (res) {
        _this3.supplierLists = res || [];
      });
    },
    handleSupplierSearch: function handleSupplierSearch(data) {
      var _this4 = this;
      this.throttle(function () {
        _this4.searchSupplier(data);
      }, 300)();
    }
  }
};